<template>
	<div class="input-with-button">
		<input
			tabindex="0"
			type="text"
			:value="getValue"
			class="input-with-button__input"
			:aria-label="placeholder"
			:placeholder="placeholder"
			@input="onInput"
			@keypress.enter="onButton"
		/>
		<button
			tabindex="0"
			class="input-with-button__button"
			@click="onButton"
		>
			{{ buttonText }}
		</button>
	</div>
</template>
<script>
	export default {
		name: 'InputWithButton',
		props: {
			value: {
				type: [String, Number, null],
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
			buttonText: {
				type: String,
				default: '입력',
			},
		},
		computed: {
			getValue() {
				return this.value;
			},
		},
		methods: {
			onInput(event) {
				this.$emit('input', event.target.value);
			},
			onButton() {
				this.$emit('click', this.value);
			},
		},
	};
</script>
<style lang="scss" scoped>
	DIV.input-with-button {
		display: inline-flex;
		width: 100%;

		.input-with-button__input {
			height: 36px;
			padding: 0 12px;
			color: #222;
			font-size: 0.875rem;
			font-weight: normal;
			border: solid 1px #dfe6ee;
			border-right: 0;
			border-radius: 4px 0 0 4px;
			background-color: #fff;
		}

		.input-with-button__button {
			display: inline-block;
			height: 36px;
			padding: 0 1em;
			background: $btn-blue;
			border: 1px solid $btn-blue;
			border-radius: 0 4px 4px 0;
			color: #fff;
			font-size: 1rem;
			font-weight: bold;

			&:focus {
				border: 1px solid rgba(#fff, 0.5);
				box-shadow: 0 0 4px 3px $btn-blue;
			}
		}
	}
</style>
